export default __webpack_public_path__ + "static/media/Belt of the Great Impi.dff93bb6.jpg";